import React from 'react';

type FilterOption = { value: string; label: string; count?: number };

export const FilterPills: React.FC<{
  ariaLabel: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
}> = ({ ariaLabel, value, options, onChange }) => (
  <div className="prototype-filter-pills" role="group" aria-label={ariaLabel}>
    {options.map(option => (
      <button key={option.value} type="button" className={value === option.value ? 'active' : ''}
        aria-pressed={value === option.value} onClick={() => onChange(option.value)}>
        <span>{option.label}</span>
        {option.count !== undefined && <b>{option.count}</b>}
      </button>
    ))}
  </div>
);
